import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';

import { Compania } from '../Models/Compania';

import { CompaniaService } from '../services/compania.service';
import { GlobalsService } from '../services/globals.service';
@Component({
  selector: 'app-compania',
  templateUrl: './compania.component.html',
  styleUrls: ['./compania.component.css']
})
export class CompaniaComponent implements OnInit {


  public compania: Compania = new Compania();
  public stringBase64: string;

  constructor(private companiaService: CompaniaService, private globalServices: GlobalsService) { }

  ngOnInit() {

    this.CargarInforcionCompania();

  }


  CargarInforcionCompania() {

    this.companiaService.ObtenerCompania(this.globalServices.ObtenerCompania()).subscribe(
      data => {
        this.compania = data;
      },
      err => {
        console.clear();
        console.log(err._body);

      });

  }

  onSubmit() {

    this.companiaService.GuardarRegistro(this.compania);


    swal("Registro guardado con éxito!", "", "success");

  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.stringBase64 = btoa(binaryString);
    this.compania.logo = this.stringBase64;
    console.log(btoa(binaryString));
  }



}
